import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import useRouteAction from 'hooks/route-action/use-route-action';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(4),
    padding: theme.typography.pxToRem(24)
  },

  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.typography.pxToRem(24),
      justifyContent: 'center'
    },
    '& button': {
      minWidth: '125px',
      whiteSpace: 'nowrap'
    }
  }
}));

interface ContactUsPanelProps {
  contactUsUrl: string;
}

const ContactUsPanel: React.FC<ContactUsPanelProps> = ({ contactUsUrl }) => {
  const classes = useStyles();
  const { t } = useTranslation('Support');

  const handleContactEmail = (): Window | null => window.open(contactUsUrl, '_blank');

  useRouteAction(({ action }) => {
    if (!action) return;
    switch (action) {
      case 'contact':
        return handleContactEmail();
      default:
        return null;
    }
  });

  return (
    <Paper className={classes.root}>
      <Grid container justify="space-between">
        <Grid item sm={9} xs={12}>
          <Typography variant="h2">{t('Need More Help?')}</Typography>
          <Typography>
            {t(
              'If you can’t find what you are looking for, we are happy to help! Please submit a ticket by clicking on the Contact Us button.'
            )}
          </Typography>
        </Grid>
        <Grid item sm={3} xs={12} className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="secondary"
            disableElevation
            onClick={handleContactEmail}
          >
            {t('Contact Us')}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ContactUsPanel;
